<template>
  <div id="app">
    <a-locale-provider :locale="zhCN">
    <!-- <a-spin :spinning="this.$store.state.loadding" tip="加载中..."> -->
         <router-view></router-view>
     <!-- </a-spin> -->
      </a-locale-provider>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
  html{
    font-family: "microsoft yahei";
  }
</style>



// WEBPACK FOOTER //
// src/App.vue